/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import UserName from 'solis/claude/element/user/name';
import InfluenceChip from 'solis/claude/element/influence.chip';
import ControlValue from 'solis/claude/element/zone/control/value';


const getBoard = ({ zoneTimeline, currentDate }) =>
{
  return zoneTimeline.getZone(currentDate).getBoard();
};


const getInfluence = ({ zoneTimeline, user, currentDate }) =>
{
  return zoneTimeline.getInfluence(user, currentDate);
};


export default (props) =>
(
  <Flex justify = 'between' align = 'center' gap = '3'>

    <Flex align = 'center' gap = '2'>

      <UserName board = {getBoard(props)} user = {props.user} />
      <InfluenceChip influence = {getInfluence(props)} />

    </Flex>

    <ControlValue {...props} />

  </Flex>
);
